import type {
  AppliesCockpitInfo,
  ApplyDetailType,
} from "@/features/integrations/modules/applies/api";

/**
 * Cockpit records the match ID asynchronously, so a just-submitted apply legitimately has none for a
 * short while. Only past this window does a missing match ID mean the apply never arrived.
 */
export const COCKPIT_DELIVERY_GRACE_PERIOD_MS = 15 * 60 * 1000;

type CockpitDeliveryState = {
  matchId: AppliesCockpitInfo["matchId"] | undefined;
  dateSubmitted: ApplyDetailType["dateSubmitted"] | undefined;
  now?: number;
};

/**
 * Whether this apply never reached Cockpit: no match ID and past the grace period. An unparseable or
 * missing submission date is not evidence of a failure, so it never flags.
 */
export function isCockpitDeliveryMissing({
  matchId,
  dateSubmitted,
  now = Date.now(),
}: CockpitDeliveryState): boolean {
  if (matchId) return false;
  if (!dateSubmitted) return false;

  const submittedAt = new Date(dateSubmitted).getTime();
  if (Number.isNaN(submittedAt)) return false;

  return now - submittedAt >= COCKPIT_DELIVERY_GRACE_PERIOD_MS;
}
